<template>
  <div class="contract-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('contract_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-gavel</v-icon>{{$t('contract.contracts')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ContractFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.start" slot-scope="{ item }">
            {{ formatDate(item['start'], 'long') }}
          </template>
          <template slot="item.valid" slot-scope="{ item }">
            <span v-if="item.valid" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
            <span v-else-if="item.valid == null" class="mr-2"><v-icon color="gray">mdi-help-circle</v-icon></span>
            <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
          </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ContractFilterForm from '../../components/contract/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ContractList',
  servicePrefix: 'Contract',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ContractFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('contract.ref'), value: 'ref' },
        { text: this.$t('contract.type'), value: 'type.name' },
        { text: this.$t('contract.customer'), value: 'customer.name' },
        { text: this.$t('contract.enable'), value: 'valid' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('contract', {
      items: 'list'
    }),
    ...mapFields('contract', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('contract', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
